// @ts-nocheck
import { useState, useEffect, useCallback } from "react"
import { supabaseClient } from "@/lib/supabase/client"

export function useNotifications(userId: string | null) {
  const [notifications, setNotifications] = useState<any[]>([])
  const [unreadCount, setUnreadCount] = useState(0)
  const [loading, setLoading] = useState(true)

  const fetch = useCallback(async () => {
    if (!userId) { setLoading(false); return }
    const { data } = await supabaseClient
      .from("notifications")
      .select("*")
      .eq("user_id", userId)
      .order("created_at", { ascending: false })
      .limit(50)
    setNotifications(data || [])
    setUnreadCount((data || []).filter((n: any) => !n.is_read).length)
    setLoading(false)
  }, [userId])

  useEffect(() => { fetch() }, [userId])

  const markAllRead = useCallback(async () => {
    if (!userId) return
    await supabaseClient.from("notifications").update({ is_read: true } as any)
      .eq("user_id", userId).eq("is_read", false)
    setNotifications(prev => prev.map(n => ({ ...n, is_read: true })))
    setUnreadCount(0)
  }, [userId])

  const markRead = useCallback(async (id: string) => {
    await supabaseClient.from("notifications").update({ is_read: true } as any).eq("id", id)
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n))
    setUnreadCount(prev => Math.max(0, prev - 1))
  }, [])

  return { notifications, unreadCount, loading, markAllRead, markRead, refetch: fetch }
}
